import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { Toaster } from 'react-hot-toast'
import { HelmetProvider } from 'react-helmet-async'
import App from './App'
import InternalGate from './pages/InternalGate'
import ComingSoon from './pages/ComingSoon';
import { AuthProvider } from './context/AuthContext'
import { BookingProvider } from './context/BookingContext'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60 * 1000, retry: 2 },
  },
})

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AuthProvider>
            <BookingProvider>
              {import.meta.env.VITE_COMING_SOON === 'true' ? <ComingSoon /> : <InternalGate><App /></InternalGate>}
              <Toaster
                position="top-right"
                toastOptions={{
                  duration: 4000,
                  style: {
                    background: '#1A0A12',
                    color: '#FDF8F5',
                    fontFamily: "'DM Sans', sans-serif",
                    borderRadius: '12px',
                    padding: '14px 18px',
                    fontSize: '14px',
                  },
                  success: { iconTheme: { primary: '#C9963A', secondary: '#FDF8F5' } },
                  error:   { iconTheme: { primary: '#e74c3c', secondary: '#FDF8F5' } },
                }}
              />
            </BookingProvider>
          </AuthProvider>
        </BrowserRouter>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
)
